export default __webpack_public_path__ + "static/media/bt.193115c6.jpg";